// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__1ZFc_"};